const orderApprovePageTitle = {
  current: '',
  first: '初审',
  review: '复审',
  final: '终审',
  reconsider: '终审复议',
  contract: '签约',
  mortgage: '先放款抵押',
  for_search: '综合查询详情',
  modify: '编辑',
  gps: 'GPS维护详情'
}

export {
  orderApprovePageTitle
}



// WEBPACK FOOTER //
// ./src/assets/js/page/approval/refs/approve.page.title.js